// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff5c6c14","453":"6a6591bf","667":"033339c6"}[chunkId] + ".chunk.js";
};